export { default } from "./privacy";
